export default __webpack_public_path__ + "static/media/hospitals.b5d59abf.jpg";